module.exports = __webpack_public_path__ + "static/media/profile.096412b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/profile.svg
// module id = 872
// module chunks = 0